module.exports = __webpack_public_path__ + "static/media/twitter-icon.174068d8.png";